import React, {Component} from "react";
import { connect } from "react-redux";
import "./Loading.scss";

class Loading extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.loading !== this.props.loading) {
            this.setState({
                show: this.props.loading.show
            });
        }
    }

    render() {
        return <>
            {
                this.state.show && 
                <div className="loading">
                    <div className="spinner"></div>
                </div>
            }
        </>;
    }
}

const mapStateToProps = state => {
    const loading = state.LoadingReducer;

    return {loading};
}

export default connect(mapStateToProps)(Loading);
